module.exports = __webpack_public_path__ + "static/media/mdi_close_.8364d92a.svg";